import infoStep from './modules/info'
import scheduleStep from './modules/schedule'
import mapStep from './modules/map'
import imagesStep from './modules/images'

import { parsePhone } from '@/utils/functions'

export default {
  namespaced: true,
  getters: {
    requestBody (state) {
      const getRadioValue = (object) => {
        if (object.radio === 'paid') {
          return object.price
        } else {
          return object.radio ? 'yes' : 'no'
        }
      }

      const title = state.infoStep.title
      const price = state.infoStep.price
      const phone = parsePhone(state.infoStep.phone)
      const coating = state.infoStep.coating
      const studdedCleats = state.infoStep.studdedCleats
      const paymentByTransfer = state.infoStep.paymentTransfer
      const formattedAddress = state.mapStep.address
      const lat = state.mapStep.coords[0]
      const lng = state.mapStep.coords[1]
      const ball = getRadioValue(state.infoStep.balls)
      const shower = getRadioValue(state.infoStep.showers)
      const changingRooms = getRadioValue(state.infoStep.changingRooms)
      const manishki = getRadioValue(state.infoStep.manishki)
      const lighting = getRadioValue(state.infoStep.lighting)

      const schedule = state.scheduleStep.days.map((item, index) => ({
        weekDay: index,
        step: 30,
        timeStart: item.weekend ? null : item.start,
        timeEnd: item.weekend ? null : item.end
      }))

      return {
        title,
        geocode: {
          formattedAddress,
          lat,
          lng
        },
        schedule,
        coating,
        price,
        phone,
        ball,
        shower,
        changingRooms,
        manishki,
        lighting,
        studdedCleats,
        paymentByTransfer,
        fieldSize: {
          width: 10,
          length: 10
        }
      }
    }
  },
  modules: {
    infoStep,
    scheduleStep,
    mapStep,
    imagesStep
  }
}
